import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import PropTypes from "prop-types";
import Channel from "./channel";

function ChannelList(props) {
  const { channels } = props;
  const orderedChannels = channels.sort((a, b) => a.last_messaged_at < b.last_messaged_at);

  return (
    <Router>
      <div className='inbox-people-list'>
        {orderedChannels.map(channel => {
          return <Channel key={channel.id} channel={channel} {...props} />;
        })}
      </div>
    </Router>
  );
}

ChannelList.propTypes = {
  channels: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default ChannelList;
